{
    "ExceptionCols": [
        {
            "display": "false",
            "ui_columnname": "Id",
            "db_columnname": "id",
            "datatype": "char",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "modifiedFlag",
            "datatype": "char",
            "mappingkey": "modifiedFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "Status",
            "db_columnname": "Status",
            "datatype": "String",
            "mappingkey": "status",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "Source",
            "db_columnname": "source",
            "datatype": "String",
            "mappingkey": "source",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "FINRA",
                    "value": "FINRA"
                },
                {
                    "label": "CLIENT",
                    "value": "CLIENT"
                }
            ],
            "sortOrder": 3
        },
        {
            "display": "true",
            "ui_columnname": "Entity",
            "db_columnname": "fileType",
            "datatype": "String",
            "mappingkey": "fileType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 4
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "RejectionID",
            "db_columnname": "rejectionID",
            "datatype": "String",
            "mappingkey": "rejectionID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 5
        },
        {
            "display": "true",
            "ui_columnname": "FirmDesignatedID",
            "db_columnname": "firmDesignatedID",
            "datatype": "String",
            "mappingkey": "firmDesignatedID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isMultiDisabled": "true",
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "InCustomerRecordIDD",
            "db_columnname": "inCustomerRecordID",
            "datatype": "String",
            "mappingkey": "inCustomerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isMultiDisabled": "true",
            "sortOrder": 11
        },
        {
            "display": "true",
            "ui_columnname": "Error Code",
            "db_columnname": "failureCode",
            "datatype": "String",
            "mappingkey": "failureCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 6
        },
        {
            "display": "true",
            "ui_columnname": "Error Description",
            "db_columnname": "failureDescription",
            "datatype": "String",
            "mappingkey": "failureDescription",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 7
        },
        {
            "display": "true",
            "ui_columnname": "ActualValue",
            "db_columnname": "actualValue",
            "datatype": "String",
            "mappingkey": "actualValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "SuggestedValue",
            "db_columnname": "suggestedValue",
            "datatype": "String",
            "mappingkey": "suggestedValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 9
        },
        {
            "display": "true",
            "ui_columnname": "CustomerRecordID",
            "db_columnname": "customerRecordID",
            "datatype": "String",
            "mappingkey": "customerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "isrequired": true,
            "sortOrder": 12
        },
        {
            "display": "true",
            "ui_columnname": "Account Type",
            "db_columnname": "accountType",
            "datatype": "String",
            "mappingkey": "accountType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "isrequired": true,
            "regexpressions":"",
            "sortOrder": 13
        },
        {
            "display": "true",
            "ui_columnname": "Account Name",
            "db_columnname": "accountName",
            "datatype": "String",
            "mappingkey": "accountName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "isrequired": false,
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "RejectionTimestamp",
            "db_columnname": "rejectionTimestamp",
            "datatype": "String",
            "mappingkey": "rejectionTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "sortOrder": 15
        },
        {
            "display": "true",
            "ui_columnname": "FileName",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "FINRAFeedbackType",
            "db_columnname": "FINRAFeedbackType",
            "datatype": "String",
            "mappingkey": "FINRAFeedbackType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 17
        },
        {
            "display": "true",
            "ui_columnname": "IdentificationDate",
            "db_columnname": "identificationDate",
            "datatype": "String",
            "mappingkey": "identificationDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 18
        },
        {
            "display": "true",
            "ui_columnname": "InconsistencyDeadline",
            "db_columnname": "inconsistencyDeadline",
            "datatype": "String",
            "mappingkey": "inconsistencyDeadline",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 19
        },
        {
            "display": "true",
            "ui_columnname": "IsNaturalPerson",
            "db_columnname": "isNaturalPerson",
            "datatype": "String",
            "mappingkey": "isNaturalPerson",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 20
        },
        {
            "display": "true",
            "ui_columnname": "Name",
            "db_columnname": "name",
            "datatype": "String",
            "mappingkey": "name",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "isOptionalFields": true,
            "sortOrder": 21
        },
        {
            "display": "true",
            "ui_columnname": "FdidRecordID",
            "db_columnname": "fdidRecordID",
            "datatype": "String",
            "mappingkey": "fdidRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 22
        },
        {
            "display": "true",
            "ui_columnname": "CustomerRejectionEventID",
            "db_columnname": "customerRejectionEventID",
            "datatype": "String",
            "mappingkey": "customerRejectionEventID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 23
        },
        {
            "display": "true",
            "ui_columnname": "AddrType",
            "db_columnname": "addrType",
            "datatype": "String",
            "mappingkey": "addrType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "isOptionalFields": true,
            "sortOrder": 24
        },
        {
            "display": "true",
            "ui_columnname": "LargeTraderRecordID",
            "db_columnname": "largeTraderRecordID",
            "datatype": "Int",
            "mappingkey": "largeTraderRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "isOptionalFields": true,
            "sortOrder": 25
        },
        {
            "display": "true",
            "ui_columnname": "AuthTraderNameID",
            "db_columnname": "authTraderNameID",
            "datatype": "Int",
            "mappingkey": "authTraderNameID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "isOptionalFields": true,
            "sortOrder": 26
        },
        {
            "display": "true",
            "ui_columnname": "SubmissionID",
            "db_columnname": "submissionID",
            "datatype": "Int",
            "mappingkey": "submissionID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 27
        },
        {
            "display": "true",
            "ui_columnname": "SubmissionFilename",
            "db_columnname": "submissionFilename",
            "datatype": "String",
            "mappingkey": "submissionFilename",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 28
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 30
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 31
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "updatedUser",
            "datatype": "String",
            "mappingkey": "updatedUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 32
        }
    ]
}